module.exports = __webpack_public_path__ + "static/startingstyle3-76c578ff29984efea6a30e2b26e306d6.mp4";